// import '@babel/polyfill'
// import 'mutationobserver-shim'
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { Auth0Plugin } from '@pantheon-systems/auth0-vue-module';
import VueRouter from 'vue-router';
import App from './App.vue';
// import axios from 'axios'
import Api from './api';
import { domain, clientId, audience } from '../auth_config.json';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// eslint-disable-next-line
import './scss/custom.scss';

// Configure Auth0 Plugin
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  connection: 'pantheonadminokta',
  onRedirectCallback: appState => {
    VueRouter.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});

// Vue.prototype.$http = axios
// Vue.prototype.$api = new api('a17a1fa0-7b1f-4380-b2e6-85a6a8f1d9b8');
// Vue.prototype.$api = new api('test-clorox');
Vue.prototype.$api = new Api('invalid');

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
